import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { Select } from "antd";
import { useGetProjectHotels } from "../../../hooks/project.hooks";
import {
  HOTEL_STATUS_LOST,
  HOTEL_STATUS_SOLD,
} from "../../../utils/hotel.utils";

const { Option } = Select;

const HotelSelect = (props) => {
  const {
    value,
    onChange,
    projectId,
    multiple,
    setHotelListRef,
    excludedHotelStatus,
    ...otherProps
  } = props;

  const { data: projectHotels, isLoading } = useGetProjectHotels(projectId, {
    enabled: !!projectId,
  });

  const filteredHotels = useMemo(() => {
    if (Array.isArray(projectHotels)) {
      return projectHotels.filter(
        (hotel) => !excludedHotelStatus.includes(hotel.hotel_status),
      );
    }
    return [];
  }, [projectHotels]);

  useEffect(() => {
    onChange(undefined);
  }, [projectId]);

  useEffect(() => {
    if (setHotelListRef !== undefined) {
      setHotelListRef(filteredHotels ?? []);
    }
  }, [filteredHotels]);

  return (
    <Select
      placeholder="Please Select Hotel(s)"
      {...(multiple ? { mode: "multiple" } : {})}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      value={value}
      onChange={onChange}
      loading={isLoading}
      {...otherProps}
    >
      {Array.isArray(filteredHotels)
        ? filteredHotels.map((hotel) => {
            return (
              <Option key={hotel._id} value={hotel._id}>
                {`${hotel.hotel_code} - ${hotel.hotel_name}`}
              </Option>
            );
          })
        : null}
    </Select>
  );
};

HotelSelect.defaultProps = {
  multiple: true,
  projectId: undefined,
  value: undefined,
  onChange: () => {},
  setHotelListRef: undefined,
  excludedHotelStatus: [HOTEL_STATUS_LOST, HOTEL_STATUS_SOLD],
};

HotelSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  onChange: PropTypes.func,
  projectId: PropTypes.string,
  multiple: PropTypes.bool,
  setHotelListRef: PropTypes.func,
  excludedHotelStatus: PropTypes.arrayOf(PropTypes.string),
};

export default HotelSelect;
